import { getImageSet } from 'Util/DataUtils';
import React from 'react';
import logo from 'Assets/img/footer_logo.png';
import logo2 from 'Assets/img/footer_logo@2x.png';
import logo3 from 'Assets/img/footer_logo@3x.png';
import IntlMessages from 'Util/IntlMessages';
import EndPoint from 'Api/EndPoint';

const logos = getImageSet([logo, logo2, logo3]);
const Footer = ({ propRef }) => {
  const openPolicy = key => {
    const width = window.outerWidth / 1.5;
    const height = window.outerHeight / 1.5;
    const left = window.screenX + window.outerWidth / 6;
    const top = window.screenY + window.outerHeight / 6;
    window.open(
      `${EndPoint.HostRoot}/terms/ko/${key}/`,
      'Policy',
      `location=no,toolbar=no,scrollbars=no,resizable=yes,status=no,menubar=no,width=${width}px,height=${height}px,top=${top}px,left=${left}px`
    );
  };

  return (
    <div ref={propRef ? propRef : null} className="footer">
      <div className="footer-contents">
        <img {...logos} alt="logo" />
        <div className="footer-body">
          <IntlMessages id="footer.body" />
        </div>
        <div className="footer-footer">
          <div className="footer-footer-left">
            <div className="footer-footer-left-text" onClick={() => openPolicy('t3')}>
              <IntlMessages id="footer.footer.left.1" />
            </div>
            <div className="footer-footer-left-text" onClick={() => openPolicy('t1')}>
              <IntlMessages id="footer.footer.left.2" />
            </div>
            <div className="footer-footer-left-text" onClick={() => openPolicy('t4')}>
              <IntlMessages id="footer.footer.left.3" />
            </div>
            <div className="footer-footer-left-text" onClick={() => window.open('http://pf.kakao.com/_xbxolKb/chat', '_blank')}>
              <IntlMessages id="footer.footer.left.4" />
            </div>
          </div>
          <div className="footer-footer-right">
            <IntlMessages id="footer.footer.right" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
